/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import InsightSelector from './InsightSelector/InsightSelector';
import TimeFrameSelector from './TimeFrameSelector/TimeFrameSelector';

import './dropdown-bar.scss';
import {
  IDenomination,
  InsightValue,
  InsightValues,
  ReactSelectOption,
  TimeFrameValue,
} from '../../common/types';
import { ReactElement, useEffect, useState } from 'react';
import { config, Denom } from '../../config/config';

import { myJackpotTimeFrames, spinsTimeFrames, TimeframeSections, AllTimeFrames } from '../../config/Timeframes';
import DenominationSelector from './DenominationSelector/DenominationSelector';

import InsightFieldSelector from './InsightFieldSelector/InsightFieldSelector';
import { useDispatch, useSelector } from 'react-redux';
import { IFilterState, IState, ITabProperties, useAppSelector } from 'appRedux/createStore';
import { AuthService } from 'services/auth';
import useWhiteLabelStyles, { WHITE_LABEL_TYPE_ENUM } from 'hooks/useWhiteLabelStyles';
import clsx from 'clsx';
import { FilterReduxCommandCreator } from 'appRedux/actions/filterCommandCreator';
import {
  FilterTypeEnum,
  IFilterType,
  InsightType,
  TimeFrameValueEnum,
  heatLegendAllInsight,
} from 'common/common';
import { FloormapReduxCommandCreator } from 'appRedux/actions/floormapCommandCreator';
import { InsightValueEnum, myJackpotsPageInsights } from 'config/Insights';
import { playerTypeEnum } from 'common/commonEnum';
import { SlotReduxCommandCreator } from 'appRedux/actions/slotCommandCreator';

interface DropdownBarProps {
  tab?: string;
  isShowShortName?: boolean;
  onClickGo?: () => void;
  onChangeValue?: () => void;
  id?: string;
  showDenominationSelector?: boolean;
  showOnlyInsightSelector?: boolean;
  fieldSelectorValues?: any;
  onClearSearch?: () => void;
}

const DropdownBar = ({
  onClickGo,
  isShowShortName = true,
  id,
  showDenominationSelector = false,
  showOnlyInsightSelector = false,
  fieldSelectorValues,
  onClearSearch,
  onChangeValue,
}: DropdownBarProps): ReactElement<any, any> | null => {
  const isProUser = useSelector<IState>(
    (state) => state.app.persistedState.userInfo?.isProUser
  ) as boolean;
  const dispatch = useDispatch();
  const floormapCommand = FloormapReduxCommandCreator(dispatch);
  const filterCommandCreator = FilterReduxCommandCreator(dispatch);

  const tabFilters = useSelector<IState>(
    (state) => state.app.persistedState.filterState[id! as IFilterType]
  ) as ITabProperties;

  const userId = useSelector<IState>((state) => state.app.persistedState.userInfo?.appUserPk);
  const isLandscape = useSelector<IState>(
    (state) => state.app.persistedState.orientationState?.isOnlyPortrait
  ) as boolean;

  const [timeFrames, setTimeFrames] = useState(config.timeframes);
  const [insights, setInsights] = useState(config.slotInsights);

  useEffect(() => {
    if (tabFilters.insight === InsightValueEnum.spins) {
      setTimeFrames(spinsTimeFrames);
    }
  }, [tabFilters]);

  useEffect(() => {
    if (id === TimeframeSections.Jackpots) {
      setInsights(myJackpotsPageInsights);
    }
  }, [id]);

  useEffect(() => {
    if (isProUser === false) {
      const selectedInsightInfo = insights.find((insight) => insight.value === tabFilters.insight);
      const selectedTimeframeInfo = timeFrames.find(
        (timeFrame) => timeFrame.value === tabFilters.timeframe
      );
      let isFreeUserAllowed = false;
      if (selectedInsightInfo?.playerTypeAccess && selectedTimeframeInfo?.playerTypeAccess) {
        isFreeUserAllowed =
          selectedInsightInfo?.playerTypeAccess.includes(playerTypeEnum.slotCheck) &&
          selectedTimeframeInfo?.playerTypeAccess.includes(playerTypeEnum.slotCheck);
      }
      if (!isFreeUserAllowed) {
        filterCommandCreator.ResetAllFilters();
      }
    }
  }, [isProUser, insights, timeFrames, tabFilters, id]);

  const isMultiSelect =
    isProUser && (id == FilterTypeEnum.hottestSlots || id == FilterTypeEnum.myplay) && isLandscape;

  const {
    timeframe: tabSelectedTimeframe,
    insight: tabSelectedInsight,
    denominations: tabSelectedDenoms,
    advancedViewInsights,
  } = tabFilters;
  const auth = new AuthService();
  let insightRestrictions: InsightValues = [InsightValueEnum.jackpots, InsightValueEnum.win_rate];
  let additionalInsights: any[] = [];
  let additionalTimeFrames: any[] = [];
  let timeFrameRestrictions = [] as TimeFrameValue[];
  const shouldHideTimeframes = tabSelectedInsight === InsightValueEnum.pop;

  if (id === TimeframeSections.Recent) {
    insightRestrictions = [
      InsightValueEnum.jackpots,
      InsightValueEnum.non_jkpt_won_per_spin,
      InsightValueEnum.jackpot_value_per_spin,
    ];
    additionalInsights = config.myPlayInsights;
  }


  if (id === TimeframeSections.Jackpots) {
    insightRestrictions = [
      ...insightRestrictions,
      InsightValueEnum.money_won,
      InsightValueEnum.avg_money_won_per_spin,
      InsightValueEnum.spins,
      InsightValueEnum.return,
      InsightValueEnum.money_played,
      InsightValueEnum.win_rate,
      InsightValueEnum.sleeper_slot_rating,
      InsightValueEnum.volatility_rating,
      InsightValueEnum.jackpots,
      InsightValueEnum.pop,
      InsightValueEnum.non_jkpt_won_per_spin,
      InsightValueEnum.jackpot_value_per_spin,
    ];
    additionalTimeFrames = myJackpotTimeFrames;
  }
  if (id === TimeframeSections.Leaderboard) {
    insightRestrictions = [
      ...insightRestrictions,
      InsightValueEnum.pop,
      InsightValueEnum.return,
      InsightValueEnum.money_played,
      InsightValueEnum.win_rate,
      InsightValueEnum.sleeper_slot_rating,
      InsightValueEnum.volatility_rating,
      InsightValueEnum.non_jkpt_won_per_spin,
      InsightValueEnum.jackpot_value_per_spin,
    ];
  }

  const restrictedInsights = [
    InsightValueEnum.jackpots,
    InsightValueEnum.jackpot_value,
    InsightValueEnum.volatility_rating,
    InsightValueEnum.avg_money_won_per_spin,
    InsightValueEnum.win_rate,
  ] as string[];

  if (restrictedInsights.includes(tabSelectedInsight)) {
    if (tabSelectedTimeframe === TimeFrameValueEnum.sinceLastJackpot) {
      filterCommandCreator.SetFilterOptions(id! as FilterTypeEnum, {
        timeframe: TimeFrameValueEnum.months1 as TimeFrameValue,
      });
    }
    timeFrameRestrictions = [...timeFrameRestrictions, TimeFrameValueEnum.sinceLastJackpot];
  }

  if (id === FilterTypeEnum.graphfilter) {
    insightRestrictions = [...insightRestrictions, InsightValueEnum.pop];
  }


  try {
    const allFrames = AllTimeFrames as Array<Partial<{ value: TimeFrameValue; sections?: string[] }>>;

    const manualRestrictions = [...timeFrameRestrictions];

    const allowed = allFrames
      .filter((tf) => tf.sections && id && tf.sections.includes(id as unknown as string))
      .map((tf) => tf.value)
      .filter(Boolean) as TimeFrameValue[];

    const additionalVals = (additionalTimeFrames || [])
      .map((t) => (t && (t.value as TimeFrameValue)) || null)
      .filter(Boolean) as TimeFrameValue[];
    const allKnown = Array.from(
      new Set([
        ...(allFrames.map((f) => f.value).filter(Boolean) as TimeFrameValue[]),
        ...additionalVals,
      ])
    ) as TimeFrameValue[];

    const computedRestrictions = allKnown.filter((v) => !allowed.includes(v));
    timeFrameRestrictions = Array.from(new Set([...computedRestrictions, ...manualRestrictions]));
    if (id === FilterTypeEnum.graphfilter || id === FilterTypeEnum.mapfilter) {
      timeFrameRestrictions = allKnown.filter((v) => v !== TimeFrameValueEnum.sinceLastJackpot);
    }
  } catch (e) {
    timeFrameRestrictions = [];
  }

  const handleInsightSelect = (selectedValue: InsightType) => {
    const insight = selectedValue.value;
    const updateFilterOptions = (options: {
      insight: InsightValue;
      timeframe?: TimeFrameValue;
      advancedViewInsights?: InsightValue[];
    }) => {
      if (isProUser) {
        const notIncludesC = advancedViewInsights.includes(insight);
        let advancedInsights;
        if (!notIncludesC) {
          const updatedAdvancedViewInsights = [...advancedViewInsights];
          updatedAdvancedViewInsights[updatedAdvancedViewInsights.length - 1] = insight;
          advancedInsights = updatedAdvancedViewInsights;
        } else {
          advancedInsights = advancedViewInsights;
        }

        options.advancedViewInsights = advancedInsights;
      }

      filterCommandCreator.SetFilterOptions(id! as FilterTypeEnum, options);
    };

    if (!isProUser) {
      switch (insight) {
        case InsightValueEnum.jackpot_value:
        case InsightValueEnum.return:
          setTimeFrames(config.timeframes);
          updateFilterOptions({ insight, timeframe: TimeFrameValueEnum.weeks1 });
          break;
        case InsightValueEnum.spins:
          setTimeFrames(spinsTimeFrames);
          updateFilterOptions({ insight, timeframe: TimeFrameValueEnum.months1 });
          break;
        default:
          setTimeFrames(config.timeframes);
          updateFilterOptions({ insight });
      }
    } else {
      switch (insight) {
        case InsightValueEnum.pop:
          setTimeFrames(config.timeframes);
          updateFilterOptions({ insight, timeframe: TimeFrameValueEnum.months1 });
          break;
        default:
          updateFilterOptions({ insight });
      }
    }

    floormapCommand.SetDefaultHeatFilterAction(heatLegendAllInsight);
  };

  const handleTimeframeSelect = ({ value }: any) => {
    filterCommandCreator.SetFilterOptions(id! as FilterTypeEnum, {
      timeframe: value as TimeFrameValue,
    });

    if (id === FilterTypeEnum.hottestSlots) {
      filterCommandCreator.SetFilterOptions(FilterTypeEnum.snapfilter as FilterTypeEnum, {
        timeframe: value as TimeFrameValue,
      });
    }
  };

  useEffect(() => {
    let isIgnore = false;
    if (!isIgnore && isProUser !== undefined) {
      handleGoClick();
    }
    return () => {
      isIgnore = true;
    };
  }, [isProUser, tabSelectedInsight, tabSelectedTimeframe, tabSelectedDenoms]);

  const handleDenominationSelect = (denominations: IDenomination[]) => {
    if (!denominations.length) return;
    filterCommandCreator.SetFilterOptions(id! as FilterTypeEnum, {
      denominations: denominations as IDenomination[],
    });
  };

  const handleInsightFieldsChange = (values: any) => {
    if (values.length >= 6 || !values.length) return;
    const advancedViewInsights = values.map((insight: ReactSelectOption) => insight.value);
    const notIncludesC = advancedViewInsights.includes(tabSelectedInsight);
    let finalInsight;
    if (!notIncludesC) {
      finalInsight = advancedViewInsights[advancedViewInsights.length - 1];
    } else {
      finalInsight = tabSelectedInsight;
    }
    filterCommandCreator.SetFilterOptions(id! as FilterTypeEnum, {
      insight: finalInsight,
      advancedViewInsights: advancedViewInsights,
    });
    onChangeValue && onChangeValue();
  };

  const handleGoClick = () => {
    if (!advancedViewInsights || !tabSelectedInsight) return;
    const updatedAdvancedViewInsights = [...advancedViewInsights];
    const isInsightIncluded = updatedAdvancedViewInsights.includes(tabSelectedInsight);

    if (!isInsightIncluded) {
      updatedAdvancedViewInsights[updatedAdvancedViewInsights.length - 1] = tabSelectedInsight;
    }
    const filterPreferences = createFilterPreferences(
      id! as FilterTypeEnum,
      tabSelectedTimeframe,
      tabSelectedInsight,
      tabSelectedDenoms,
      isInsightIncluded,
      advancedViewInsights,
      updatedAdvancedViewInsights
    );

    Object.keys(filterPreferences).forEach((id) => {
      const newPreference = filterPreferences[id as keyof IFilterState];
      if (newPreference) {
        filterCommandCreator.SetFilterOptions(id as FilterTypeEnum, newPreference);
      }
    });
    auth.trackPreference(filterPreferences).subscribe();

    if (onClickGo) {
      onClickGo();
    }
  };

  const createFilterPreferences = (
    id: FilterTypeEnum,
    tabSelectedTimeframe: TimeFrameValue,
    tabSelectedInsight: InsightValue,
    tabSelectedDenoms: IDenomination[],
    isInsightIncluded: boolean,
    advancedViewInsights: InsightValue[],
    updatedAdvancedViewInsights: InsightValue[]
  ): Partial<IFilterState> => {
    const updatedFilterPreference = {
      timeframe: tabSelectedTimeframe,
      insight: tabSelectedInsight,
      denominations: tabSelectedDenoms,
      advancedViewInsights: isInsightIncluded ? advancedViewInsights : updatedAdvancedViewInsights,
    };

    // If the filter type is 'hottestSlots', updating this will also reflect in both graph and map filters
    if (id == FilterTypeEnum.hottestSlots) {
      return {
        hottestSlots: updatedFilterPreference,
        graphfilter: updatedFilterPreference,
        mapfilter: updatedFilterPreference,
      };
    } else {
      return {
        [id]: {
          timeframe: tabSelectedTimeframe,
          insight: tabSelectedInsight,
          denominations: tabSelectedDenoms,
          advancedViewInsights: isInsightIncluded
            ? advancedViewInsights
            : updatedAdvancedViewInsights,
        },
      };
    }
  };

  const resetAllFilters = () => {
    filterCommandCreator.ResetAllFilters();
  };

  useEffect(() => {
    if (userId === null) {
      resetAllFilters();
    }
  }, [userId]);

  const styles = useWhiteLabelStyles(WHITE_LABEL_TYPE_ENUM.CANVAS);

  const getInsightSize = () => {
    if (tabSelectedInsight === InsightValueEnum.pop || showOnlyInsightSelector) {
      return '12';
    }

    if (isLandscape) {
      return showDenominationSelector ? '4' : '6';
    }

    return '6';
  };
  return (
    <div
      className={clsx(
        'time-filter',
        id !== FilterTypeEnum.graphfilter && id !== FilterTypeEnum.mapfilter && 'bg-primary'
      )}
      style={
        id !== FilterTypeEnum.graphfilter && id !== FilterTypeEnum.mapfilter ? styles : undefined
      }
    >
      <IonGrid className="ion-no-padding">
        <IonRow className="ion-align-items-center time-filter-row-container">
          <IonCol no-padding className="ion-no-padding">
            <IonRow className="dropdown-selector-group-list">
              {showDenominationSelector && (
                <IonCol size={isLandscape ? (showDenominationSelector ? '4' : '6') : '12'}>
                  <DenominationSelector options={Denom} onSelect={handleDenominationSelect} />
                </IonCol>
              )}
              <IonCol size={getInsightSize()} id={id + '_insight'}>
                {isMultiSelect && (
                  <InsightFieldSelector
                    onChange={handleInsightFieldsChange}
                    value={fieldSelectorValues}
                  />
                )}

                {!isMultiSelect && (
                  <InsightSelector
                    id={id}
                    isShowShortName={isShowShortName}
                    restrictions={insightRestrictions}
                    insights={insights}
                    additionalInsights={additionalInsights}
                    onSelect={handleInsightSelect}
                    customCls="insights-dropdown"
                    selectedInsight={tabSelectedInsight}
                    isDisabled={false}
                  />
                )}
              </IonCol>
              {tabSelectedInsight !== InsightValueEnum.pop && !showOnlyInsightSelector && (
                <IonCol
                  size={isLandscape ? (showDenominationSelector ? '4' : '6') : '6'}
                  className={`${shouldHideTimeframes ? 'invisible' : ''}`}
                  id={id + '_timeframe'}
                >
                  <TimeFrameSelector
                    isShowShortName={isShowShortName}
                    restrictions={timeFrameRestrictions}
                    additionalTimeFrame={additionalTimeFrames}
                    onSelect={handleTimeframeSelect}
                    value={tabSelectedTimeframe}
                    isDisabled={shouldHideTimeframes ? true : false}
                    customCls="timeframes-dropdown"
                    timeFrames={timeFrames}
                  />
                </IonCol>
              )}
            </IonRow>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

export default DropdownBar;
